import { render, staticRenderFns } from "./BatimentListItem.vue?vue&type=template&id=222284bb&scoped=true&"
import script from "./BatimentListItem.vue?vue&type=script&lang=js&"
export * from "./BatimentListItem.vue?vue&type=script&lang=js&"
import style0 from "./BatimentListItem.vue?vue&type=style&index=0&id=222284bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222284bb",
  null
  
)

export default component.exports